import { __values } from "tslib";
import template from './new-address-form.html';
export var NewAddressFormComponent = {
    template: template,
    bindings: {},
    controller: /** @class */ (function () {
        function NewAddressFormComponent(AddressService, $q, Util) {
            'ngInject';
            this.addressTypes = [{ id: 0, type: 'Business' }, { id: 1, type: 'Patient' }];
            this.AddressService = AddressService;
            this.$q = $q;
            this.Util = Util;
        }
        NewAddressFormComponent.prototype.$onInit = function () {
            this.initialCountry = false;
            this.setupForm();
        };
        NewAddressFormComponent.prototype.changeAddressType = function (addrType) {
            this.showUsOnly = addrType.type === 'Patient';
            this.selectedAddressType = addrType;
            this.isDefault = addrType.type !== 'Patient';
        };
        /**
         * Create filter function for a query string
         */
        NewAddressFormComponent.prototype.createFilterFor = function (query, typesProp) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(type) {
                return (angular.lowercase(type[typesProp]).indexOf(lowercaseQuery) === 0);
            };
        };
        NewAddressFormComponent.prototype.querySearch = function (query, types, typesProp) {
            var self = this;
            if (types != undefined && typesProp != undefined) {
                var results = query ? self[types].filter(self.createFilterFor(query, typesProp)) : self[types];
                return results;
            }
            return {};
        };
        NewAddressFormComponent.prototype.setupForm = function () {
            var self = this;
            if (this.updateForm == true || this.updateForm == 'true') {
                this.updateForm = true;
                this.createForm = false;
                if (this.address) {
                    this.$log.debug('Received address -> ', this.address);
                    this.country = {
                        countryCode: this.address.countryCode,
                        countryName: this.address.countryName
                    };
                    this.enteredRegion = this.address.regionName;
                }
            }
            else {
                this.updateForm = false;
                this.createForm = true;
                this.country = {
                    countryCode: 'US',
                    countryName: 'United States',
                    postalCodeRegex: '^\\d{5}(?:[-\\s]*\\d{4})?$',
                    regionCodeRequired: true
                };
                this.postalCodePattern = new RegExp(this.country.postalCodeRegex);
            }
            self.$q.all([
                this.AddressService.getCountries(),
                this.AddressService.getRegionsForCountry(self.country.countryCode)
            ])
                .then(function (responses) {
                if (responses[0].status != 200 || responses[0].data.errors.length ||
                    responses[1].status != 200 || responses[1].data.errors.length) {
                    if (responses[0].status != 200 || (responses[0].data && responses[0].data.errors && responses[0].data.errors.length)) {
                        self.handleApiError(responses[0]);
                    }
                    if (responses[1].status != 200 || (responses[1].data && responses[1].data.errors && responses[1].data.errors.length)) {
                        self.handleApiError(responses[1]);
                    }
                }
                else {
                    self.countries = responses[0].data.response.currentPage;
                    self.allCountries = self.countries;
                    self.states = responses[1].data.response.currentPage;
                    if (self.onSetupCountry == null) {
                        self.onSetupCountry = self.country.countryCode;
                    }
                    self.initialCountry = true;
                    self.Util.resetApiError(self);
                    self.setupState(self.address);
                    self.setupCountry();
                }
            });
        };
        NewAddressFormComponent.prototype.validateField = function (form) {
            // When country is changed, Set dirty and touched flags
            // for State and PostalCode fields
            if (form.state1) {
                form.state1.$setDirty();
                form.state1.$setTouched();
            }
            if (form.postalCode) {
                form.postalCode.$setDirty();
                form.postalCode.$setTouched();
            }
            if (form.autocompleteField) {
                form.autocompleteField.$setDirty();
                form.autocompleteField.$setTouched();
            }
        };
        NewAddressFormComponent.prototype.isCtryChanged = function () {
            this.formLoad = true;
        };
        NewAddressFormComponent.prototype.changeCountry = function (country, form, isUpdate) {
            if (!this.formLoad) {
                return false;
            }
            this.settingsService.isFormPristine = form.$pristine;
            if (country) {
                this.$scope.newAddrsForm.countryCode = country.countryCode;
            }
            if (country != undefined) {
                var self_1 = this;
                self_1.state = null;
                this.initialCountry = false;
                this.searchText = '';
                this.AddressService.getRegionsForCountry(country.countryCode).then(function (response) {
                    if (response.status != 200 || (response.data && response.data.errors && response.data.errors.length)) {
                        self_1.handleApiError(response);
                    }
                    else {
                        self_1.states = response.data.response.currentPage;
                        self_1.$scope.$emit('countryUpdated', country);
                    }
                    self_1.address.countryCode = country.countryCode;
                    self_1.address.countryName = country.countryName;
                    if (isUpdate) {
                        self_1.updateCountry(form);
                        self_1.settingsService.isAddressValid = form.$valid;
                    }
                });
                if (country.postalCodeRegex) {
                    self_1.postalCodePattern = new RegExp(country.postalCodeRegex);
                    this.$log.debug('Predefined Postal Code Pattern -> ', self_1.postalCodePattern);
                    self_1.isPostalCodeReqd = true;
                }
                else {
                    this.$log.debug('Default Postal Code Pattern -> ', self_1.defaultPostalCodePattern);
                    self_1.isPostalCodeReqd = false;
                }
            }
        };
        NewAddressFormComponent.prototype.setupState = function (address) {
            var self = this;
            if (address) {
                for (var i = 0; i < self.states.length; i++) {
                    if (self.states[i].regionCode == address.regionCode) {
                        self.state = {};
                        self.state.regionCode = self.states[i].regionCode;
                        self.state.regionName = self.states[i].regionName;
                        self.oldStateVal = {
                            'regionCode': self.states[i].regionCode,
                            'regionName': self.states[i].regionName
                        };
                        break;
                    }
                }
            }
        };
        NewAddressFormComponent.prototype.setupCountry = function () {
            var self = this;
            if (self.countries) {
                // Get US country Object
                var usCountry = self.countries.filter(function (x) {
                    return x.countryCode == 'US';
                });
                // Build List of Countries Excluding US
                self.countries = self.countries.filter(function (x) {
                    return x.countryCode != 'US';
                });
                // Sort rest of the countries by Name
                self.countries = self.countries.sort(function (a, b) {
                    return a.countryName.localeCompare(b.countryName);
                });
                // Add US country Object to the top of the list
                self.countries.unshift(usCountry[0]);
                for (var i = 0; i < self.countries.length; i++) {
                    if (self.countries[i].countryCode == self.country.countryCode) {
                        self.country = self.countries[i];
                        if (self.country.postalCodeRegex) {
                            self.postalCodePattern = new RegExp(self.country.postalCodeRegex);
                            self.isPostalCodeReqd = true;
                        }
                        else {
                            self.postalCodePattern = self.defaultPostalCodePattern;
                            self.isPostalCodeReqd = false;
                        }
                        break;
                    }
                }
            }
        };
        NewAddressFormComponent.prototype.updateFormAdd = function (form) {
            this.settingsService.isAddressValid = form.$valid;
            this.settingsService.isFormPristine = form.$pristine;
            var stateField = false, postalCodeField = false;
            if (form.selectState == undefined && !this.country.regionCodeRequired) {
                stateField = true;
            }
            else if (form.selectState != undefined && this.country.regionCodeRequired) {
                stateField = true;
            }
            if (form.postalCode == undefined && !this.isPostalCodeReqd) {
                postalCodeField = true;
            }
            else if (form.postalCode != undefined && this.isPostalCodeReqd && form.postalCode.$valid) {
                postalCodeField = true;
            }
            if (form.recipientName.$valid && form.address1.$valid && form.address2.$valid
                && postalCodeField && this.updateForm &&
                stateField && form.city.$valid &&
                form.country.$valid && form.$valid) {
                this.$log.debug('I will update Address to: ' + this.address + ',' +
                    '               for addressKey: ' + this.address.addressKey);
                this.updateAddress(this.address, 'Address');
            }
        };
        NewAddressFormComponent.prototype.updateFormDefaultAdd = function (form) {
            this.settingsService.isAddressValid = form.$valid;
            this.settingsService.isFormPristine = form.$pristine;
            var stateField = false, postalCodeField = false;
            if (form.autocompleteField == undefined && !this.country.regionCodeRequired) {
                stateField = true;
            }
            else if (form.autocompleteField != undefined && form.autocompleteField.$valid && this.country.regionCodeRequired) {
                stateField = true;
            }
            if (form.postalCode == undefined && !this.isPostalCodeReqd) {
                postalCodeField = true;
            }
            else if (form.postalCode != undefined && this.isPostalCodeReqd && form.postalCode.$valid) {
                postalCodeField = true;
            }
            if (form.address1.$valid && form.address2.$valid
                && postalCodeField && this.updateForm &&
                stateField && form.city.$valid &&
                form.country.$valid && form.$valid) {
                this.$log.debug('I will update Address to: ' + this.address + ',' +
                    '               for addressKey: ' + this.address.addressKey);
                this.updateAddress(this.address, 'Address');
            }
        };
        NewAddressFormComponent.prototype.updateRecipient = function (form) {
            if (form.recipientName.$valid && form.$valid) {
                this.$log.debug('I will update recipientName to: ' + this.address.recipientName + ',' +
                    '               for addressKey: ' + this.address.addressKey);
                this.updateAddress(this.address, 'Recipient Name');
            }
        };
        NewAddressFormComponent.prototype.updateLine1 = function (form) {
            this.settingsService.isAddressValid = form.$valid;
            this.settingsService.isFormPristine = form.$pristine;
            if (form.address1.$valid && form.$valid) {
                this.$log.debug('I will update line1 to: ' + this.address.line1 + ', for addressKey: ' + this.address.addressKey);
                this.updateAddress(this.address, 'Address Line 1');
            }
        };
        NewAddressFormComponent.prototype.updateLine2 = function (form) {
            this.settingsService.isAddressValid = form.$valid;
            this.settingsService.isFormPristine = form.$pristine;
            if (form.address2.$valid && form.$valid) {
                this.$log.debug('I will update line2 to: ' + this.address.line2 + ', for addressKey: ' + this.address.addressKey);
                this.updateAddress(this.address, 'Address Line 2');
            }
        };
        NewAddressFormComponent.prototype.updatePostalCode = function (form) {
            this.settingsService.isAddressValid = form.$valid;
            this.settingsService.isFormPristine = form.$pristine;
            if (form.postalCode.$valid && form.$valid) {
                this.$log.debug('I will update postal code to: ' + this.address.postalCode + ', for addressKey: ' + this.address.addressKey);
                this.updateAddress(this.address, 'Postal Code');
            }
        };
        NewAddressFormComponent.prototype.updateState = function (form) {
            var self = this;
            self.settingsService.isAddressValid = form.$valid;
            self.settingsService.isFormPristine = form.$pristine;
        };
        NewAddressFormComponent.prototype.updateRegion = function (form, selectedState) {
            if (!this.paymentCreditCard && !this.formLoad && !this.isAddNewShippingAddress) {
                return false;
            }
            if (this.$state.current.name === 'accountInfo' && this.rxConfig != undefined) {
                this.rxConfig.oldState = typeof this.address.regionCode == 'object' ? this.address.regionCode.regionCode : this.address.regionCode;
                this.rxConfig.newState = selectedState; // form.autocompleteField.$modelValue;
            }
            this.settingsService.isAddressValid = form.$valid;
            this.settingsService.isFormPristine = form.$pristine;
            if (selectedState) {
                this.address.regionCode = selectedState.regionCode;
                this.address.regionName = selectedState.regionName;
            }
            if (form.$valid) {
                var savedRegion = {};
                var newAddr = angular.copy(this.address);
                if (selectedState) {
                    newAddr.regionCode = selectedState.regionCode;
                    newAddr.regionName = selectedState.regionName;
                    savedRegion = selectedState;
                    this.$log.debug('I will update region to: ', newAddr.regionCode + ', for addressKey: ' + this.address.addressKey);
                    if (this.paymentCreditCard) {
                        if (this.isNewCreditCard && this.formLoad) {
                            this.updateAddress(newAddr, 'State');
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        if (!this.manageShipping) {
                            this.updateAddress(newAddr, 'State');
                        }
                    }
                    if (!this.isDefaultCreditcard) {
                        this.address.regionCode = savedRegion.regionCode;
                        this.address.regionName = savedRegion.regionName;
                    }
                }
            }
        };
        NewAddressFormComponent.prototype.updateCity = function (form) {
            this.settingsService.isAddressValid = form.$valid;
            this.settingsService.isFormPristine = form.$pristine;
            if (form.city.$valid && form.$valid) {
                this.$log.debug('I will update city to: ' + this.address.city + ', for addressKey: ' + this.address.addressKey);
                this.updateAddress(this.address, 'City');
            }
        };
        NewAddressFormComponent.prototype.updateCountry = function (form) {
            this.settingsService.isAddressValid = form.country.$valid;
            this.settingsService.isFormPristine = form.$pristine;
            // if (form.country.$valid && form.$valid && this.address.countryCode != this.country.countryCode) {
            if (form.country.$valid && form.$valid && !this.manageShipping) {
                this.$log.debug('I will update country to: ' + this.address.countryCode + ', for addressKey: ' + this.address.addressKey);
                this.updateAddress(this.address, 'Country');
            }
            this.$log.debug('In UpdateCountry Address ->', this.address);
        };
        NewAddressFormComponent.prototype.setCountry = function (item) {
            if (item) {
                this.$scope.addrForm.countryCode = item.countryCode;
            }
        };
        NewAddressFormComponent.prototype.isValidForm = function (form) {
            if (form.$invalid) {
                return true;
            }
            else {
                return false;
            }
        };
        NewAddressFormComponent.prototype.$onChanges = function (changes) {
            var e_1, _a;
            var _this = this;
            var self = this;
            if (changes.address) {
                if (this.address) {
                    if (this.address.regionCode || this.address.regionName) {
                        this.state = {
                            regionCode: this.address.regionCode,
                            regionName: this.address.regionName
                        };
                    }
                    else {
                        self.state = null;
                        self.enteredRegion = '';
                    }
                    if (this.address.countryCode || this.address.countryName) {
                        var origCountry = this.country;
                        this.country = {
                            countryCode: this.address.countryCode,
                            countryName: this.address.countryName
                        };
                        this.setupCountry();
                        if (origCountry && origCountry.countryCode != this.address.countryCode) {
                            this.addrSvc.getRegionsForCountry(this.address.countryCode).then(function (response) {
                                if (response.status != 200 || (response.data && response.data.errors && response.data.errors.length)) {
                                    self.handleApiError(response);
                                }
                                else {
                                    self.states = response.data.response.currentPage;
                                    _this.setupState(_this.address);
                                    self.$scope.$emit('countryUpdated', _this.country);
                                }
                            });
                        }
                    }
                }
                // this.address = angular.copy(this.address);
            }
            if (changes.updateForm) {
                this.updateForm = angular.copy(this.updateForm);
            }
            if (changes.createForm) {
                this.createForm = angular.copy(this.createForm);
            }
            if (changes.creditCard) {
                this.creditCard = angular.copy(this.creditCard);
            }
            if (changes.showUsOnly) {
                if (this.showUsOnly) {
                    var usCountry = void 0;
                    if (this.countries && this.countries.length) {
                        usCountry = self.countries.filter(function (x) {
                            return x.countryCode == 'US';
                        })[0];
                    }
                    else {
                        usCountry = {
                            countryCode: 'US',
                            countryName: 'United States',
                            postalCodeRegex: '^\\d{5}(?:[-\\s]*\\d{4})?$',
                            regionCodeRequired: true
                        };
                    }
                    if (this.allCountries.length == 0) {
                        this.allCountries = angular.copy(this.countries);
                    }
                    if (this.countries) {
                        this.countries.length = 0;
                    }
                    this.countries = [];
                    this.countries.push(usCountry);
                    this.country = this.countries[0];
                    this.setupCountry();
                }
                else {
                    if (this.allCountries.length) {
                        this.countries = this.allCountries;
                        this.setupCountry();
                    }
                }
                this.showUsOnly = angular.copy(this.showUsOnly);
            }
            if (changes.resetForm && changes.resetForm.currentValue) {
                // angular.copy({}, self.$scope.addrForm);
                this.initialCountry = true;
                var controlNames = Object.keys(self.$scope.addrForm).filter(function (key) { return key.indexOf('$') !== 0; });
                try {
                    // Set each control back to undefined. This is the only way to clear validation messages.
                    // Calling `form.$setPristine()` won't do it (even though you wish it would).
                    for (var controlNames_1 = __values(controlNames), controlNames_1_1 = controlNames_1.next(); !controlNames_1_1.done; controlNames_1_1 = controlNames_1.next()) {
                        var name_1 = controlNames_1_1.value;
                        var control = self.$scope.addrForm[name_1];
                        if (control.$setViewValue) {
                            if (name_1 != 'country') {
                                control.$setViewValue(undefined);
                                control.$setPristine();
                                control.$setUntouched();
                                if (name_1 === 'selectState') {
                                    self.state = {
                                        regionCode: '',
                                        regionName: ''
                                    };
                                }
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (controlNames_1_1 && !controlNames_1_1.done && (_a = controlNames_1.return)) _a.call(controlNames_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                this.setupForm();
                self.$scope.newAddrsForm.$setPristine();
                self.$scope.newAddrsForm.$setUntouched();
            }
        };
        return NewAddressFormComponent;
    }())
};
//# sourceMappingURL=new-address-form.component.js.map